export default __webpack_public_path__ + "static/screenshot@2x-22fedaf1e3ebaa11bbab39ac378b232e.png";